/**
 * Light or dark, decided before the console's first paint, inside the mobile app.
 *
 * `ThemeProvider` applies the theme in an effect, after the page has already
 * painted once in light. In a browser tab that is a brief flicker; in the
 * mobile app the native screen around the page takes the page's colour, so in
 * dark mode the whole phone turned light for a moment on every load. This runs
 * in <head> and puts the same class on <html> the provider would, from the same
 * saved choice, before anything paints.
 *
 * Only inside the app (`window.__DECODA_NATIVE__`, injected before any page
 * script): some web pages render without the provider and are designed light,
 * and this must not turn them dark in a browser.
 */
import { presetThemes } from "@/lib/themes";

export const THEME_STORAGE_KEY = "decoda-theme";
export const CUSTOM_THEME_STORAGE_KEY = "decoda-custom-theme";

const BASE_MODES = Object.fromEntries(
  presetThemes.map((theme) => [theme.id, theme.baseMode]),
);

export const NATIVE_THEME_BOOT_SCRIPT = `(function () {
  try {
    if (!window.__DECODA_NATIVE__) return;
    var modes = ${JSON.stringify(BASE_MODES)};
    var custom = localStorage.getItem(${JSON.stringify(CUSTOM_THEME_STORAGE_KEY)});
    var saved = localStorage.getItem(${JSON.stringify(THEME_STORAGE_KEY)});
    var mode = (custom && modes[custom]) ||
      (saved === "light" || saved === "dark" ? saved : null) ||
      (window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light");
    var root = document.documentElement;
    root.classList.remove("light", "dark");
    root.classList.add(mode);
    root.style.colorScheme = mode;
  } catch (e) {}
})();`;
